<section class="container-fluid summary-panel">
    <app-data-list [loadPage]="loadPageForVehicle" [(filters)]="filters" [filtersBase]="filtersBase" [itemTemplate]="itemTemplate"
                   [extraActionFields]="assignTo" [filtersComponent]="dataFilters" [pageSize]="MAX_PAGE_SIZE"
                   [draggableName]="draggableListName" [draggable]="true" [hidePagination]="true"
                   (onPageChange)="pageChanged()" (onLoad)="onLoad($event)" (beforeReset)="beforeReset()"
                   (onItemPositionChanged)="changePosition($event)">
        <app-data-filters #dataFilters [opened]="true" [fullWidth]="true" [titleKey]="'local-loads.reorder.vehicle.page-title'">
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-autocomplete class="data-filter-vehicle" [labelKey]="'local-loads.search.list.filters.vehicle.label'"
                                              [name]="'vehicle'"
                                              [(model)]="filters.vehicles" [options]="vehicleSearchOptions"
                                              [placeholderKey]="'local-loads.search.list.filters.vehicle.placeholder'"
                                              [notFoundTextKey]="'local-loads.search.list.filters.vehicle.notfound'"
                                              [useOptionValueExtractor]="true">
                </app-data-filter-autocomplete>
                <app-data-filter-switch class="data-filter-switch"
                                        [labelKey]="'local-loads.search.list.filters.vehicle.last_completed'"
                                        [(model)]="filters.showCompleted"></app-data-filter-switch>
            </app-data-filter-group>

        </app-data-filters>
        <ng-template #assignTo let-items="items">
            <div class="assign-to-container" *ngIf="canAssignVehicle">
                <i (click)="unassignAllLoads(unassignLocalLoads ,items)" class="fas fa-angle-double-right fa-2x"></i>

            </div>
        </ng-template>
        <ng-template #itemTemplate let-item="item" let-items="items">
            <div class="ibox float-e-margins loads-list">
                <div class="ibox-title collapsible border-primary"
                     [class.collapsed]="!item.expanded"
                     (click)="item.expand()">


                    <div class="local-load-list-item">
                        <a class="collapse-link" draggable="false">
                            <i class="fa" [ngClass]="{ 'fa-plus': !item.expanded, 'fa-minus': item.expanded }"></i>
                        </a>

                        <div class="local-load-list-item-column mainInfos">
                            <div class="local-load-list-item">
                                <div class="local-load-list-item-column">
                                    <div [title]="item.shipmentNumbers" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.shipment-numbers',
                                         params: {shipmentNumbers: item.shipmentNumbers}}]">
                                    </div>
                                </div>
                                <div class="local-load-list-item-column">
                                    <div [title]="item.loadNumber">
                                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.load-number'}]"></span>
                                        <span>#{{ item.loadNumber }}</span>
                                        <span class="item-blujay-logo" *ngIf="item.localLoadImport.source === 'BLUJAY'">
                                            <img class="blujay-logo" src="/assets/blujay-logo.png" alt="BluJay"/>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="local-load-list-item">
                                <div class="local-load-list-item-column shipmentInfos">
                                    <div class="ellipsisInfos" [title]="item.stops[0].location.name">
                                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.collect-from',
                                              params: {location: item.stops[0].location.name}}]"></span>
                                    </div>

                                    <div class="ellipsisInfos" [title]="item.stops[item.stops.length - 1].location.name">
                                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.deliver-to',
                                              params: {location: item.stops[item.stops.length - 1].location.name}}]"></span>
                                    </div>
                                </div>
                                <div class="local-load-list-item-column shrink statusAlign">
                                    <app-local-load-status [status]="item.status"></app-local-load-status>
                                </div>
                            </div>
                        </div>

                        <div class="local-load-list-item-column control-buttons shrink">
                            <i (click)="moveVehicleToTop(item)" class="fas fa-angle-double-up fa-lg"></i>
                            <i (click)="moveVehicleToBottom(item, items)" class="fas fa-angle-double-down fa-lg"></i>
                        </div>

                        <i class="fas fa-bars fa-lg drag-button"></i>

                        <div class="local-load-list-item-column shrink" *ngIf="canAssignVehicle">
                            <div class="ibox-tools">
                                <a (click)="unassignLoad(item)" class="unassign-load">
                                    <i class="fas fa-angle-right fa-lg"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ibox-content no-padding local-load-list-item-stops" *ngIf="item.expanded">
                    <div *ngFor="let stop of item.stops" class="local-load-list-item-stop">
                        <div *ngIf="stop.type === 'Pick'" [title]="stop.location.name" class="local-load-list-item-stop-location">
                            <span class="chep-icon-pick-up"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.collect-from',
                                  params: {location: stop.location.name}}]"></span>
                        </div>
                        <div *ngIf="stop.type === 'Drop'" [title]="stop.location.name" class="local-load-list-item-stop-location">
                            <span class="chep-icon-drop-off"></span>
                            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.deliver-to',
                                  params: {location: stop.location.name}}]"></span>
                        </div>
                        <div [title]="stop.plannedArrival | fullDate" class="local-load-list-item-stop-arrival">
                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.planned-arrival',
                              params: { date: stop.plannedArrival | fullDate: false }}]"></span>
                        </div>
                        <div [title]="stop.plannedDeparture | fullDate" class="local-load-list-item-stop-departure">
                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.list.planned-departure',
                              params: { date: stop.plannedDeparture | fullDate: false }}]"></span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </app-data-list>
</section>

<ng-template #unassignLocalLoads>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.reorder.modal.unassign.body'}]"></span>
</ng-template>
